import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthService from "../../Helpers/Auth.service";
import api from "./../../Interceptors/Interceptor";
import { Link } from "react-router-dom";
import { Card, Spinner } from "react-bootstrap";
import axios from "axios";
import OutsideClickedComponent from "./utils/OutsideClickedComponent";
import { Skeleton } from "antd";
import { Capacitor } from "@capacitor/core";
import { useDispatch } from "react-redux";
import { searchActions } from "../../store/slice/search-slice";
import { shopActions } from "../../store/slice/shop-slice";
import { FaArrowLeft } from "react-icons/fa";


const brandPageSize = 96;



const Header = ({ totalQuantity, setTotalQuantity }) => {

  const [showMobile, setShowMobile] = useState(false);

  const dispatch = useDispatch();

  const userid = localStorage.getItem("userid");
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [brandList, setBrandList] = useState([]);
  // const [productList, setProductList] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [value, setValue] = useState("");
  const [subTotal, setSubTotal] = useState();
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryList, setCategoryList] = useState([]);
  const [category, setCategory] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [slice, setslice] = useState(16);
  const [TotalProducts, setTotalProducts] = useState();
  const blurTimeoutRef = useRef(null);

  const [isOptionVisible, setIsOptionVisible] = useState(false)
  const open = () => { setIsOptionVisible(true) }
  const close = () => {
    setTimeout(() => {
      setIsOptionVisible(false);

    }, 200);
  }
  const sourceDivRef = useRef(null);
  const targetDivRef = useRef(null);
  const [sourceDivWidth, setSourceDivWidth] = useState(0);

  useEffect(() => {
    // Calculate the width of the source div
    if (sourceDivRef.current) {
      const width = sourceDivRef.current.offsetWidth;
      setSourceDivWidth(width);
    }
  }, []);

  const { pathname } = useLocation();

  useEffect(() => {
    console.log({ pathname });
    if (pathname !== "/product-detail" && pathname !== "/search") {
      dispatch(searchActions.setPageNo(0));
      dispatch(searchActions.setSearchProductList([]));

    }
    if (pathname !== "/product-detail" && pathname !== "/shop") {
      dispatch(shopActions.setPageNo(0));
      dispatch(shopActions.setShopProductList([]));
      dispatch(shopActions.setCurrentUrl(""));
    }
    return () => { }
  }, [pathname])


  // useEffect(() => {
  //   // window.scrollTo(0, 0);
  //   window.scrollTo({
  //     top: 0,
  //     behavior: 'auto', // Smooth scroll behavior
  //   });
  //   console.log({ pathname });
  // }, [pathname]);


  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  useEffect(() => {
    // Set the width of the target div based on the width of the source div
    if (targetDivRef.current) {
      targetDivRef.current.style.width = `${sourceDivWidth}px`;
    }
  }, [sourceDivWidth]);


  const [pageNo, setPageNo] = useState(0);
  const [hasMoreBrand, setHasMoreBrand] = useState(true)

  useEffect(() => {
    const source = axios.CancelToken.source();
    setTimeout(() => setLoading(false), 2000);
    async function fetchCategories() {
      try {
        const response = await api.get('/api/app/Categories', { cancelToken: source.token });
        const data = response.data;
        setCategoryList(data);
        setCategory();
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    }
    async function fetchCartItems() {
      try {
        if (token != null) {
          let urltext = `/api/app/Carts/GetTotalCart/${userid}`;
          const res = await api.get(urltext, { cancelToken: source.token });

          if (res.status == 200) {
            setCartItems(res.data);
            const totalQty = res.data.cartsTotal;

            if (setTotalQuantity) {
              setTotalQuantity(totalQty);
            }
            // const result = res.data.reduce(
            //   (total, currentValue) => (total = total + currentValue.price),
            //   0
            // );
            // setSubTotal(result);
          }
        }
      } catch (err) {
        console.log(err.message);
      }
    }
    // fetchCategories();

    fetchCartItems();
    // Updatecartitems()

    return () => {
      source.cancel("Unmounting Cancel Call");
    }
  }, []);

  const sourceRef = useRef();
  useEffect(() => {
    let isComponentMounted = true;
    sourceRef.current = axios.CancelToken.source();
    isComponentMounted && fetchBrands();

    return () => {
      isComponentMounted = false;
      sourceRef.current.cancel();
    }
  }, [])

  async function fetchBrands(number = null) {
    try {
      const skipNumber = number ? number : 0;
      const response = await api.get('/api/app/Brands/LoadBrandsByPriority'
        , {
          cancelToken: sourceRef.current?.token,
          params: {
            skip: skipNumber,
            take: brandPageSize
          }
        });
      const data = await response.data;
      if (data.length === 0 && data.length < brandPageSize) {
        setHasMoreBrand(false);
      }
      if (skipNumber === 0) {
        setBrandList(data);
        setTotalProducts(data.length);

      } else {
        setBrandList(c => {
          return [...c, ...data];
        });
        setTotalProducts(c => (c + data.length));

      }
    } catch (error) {
      console.error('Error fetching brands:', error);
    }
  }


  useEffect(() => {
    // Calculate the total quantity when cartItems change
    // let quantitySum = 0;
    // for (const item of cartItems) {
    //   quantitySum += item.qty;
    // }
    if (setTotalQuantity) {
      setTotalQuantity(cartItems.cartsTotal);
    }
  }, [cartItems]);


  const handleDelete = async (id) => {
    let url = `${process.env.REACT_APP_API_BASE_URL}/api/app/Carts/${id}`;

    if (!userid) {
      return;
    }

    const model = {
      token: token,
      id: id,
    };

    try {
      const response = await api.delete(url, {
        headers: AuthService.getHeadersWithAuthToken(),
        data: model, // Pass the data directly as `data` property in Axios delete request
      });

      if (response.status === 200) {
        toast.info(`Lowered Item Quantity!`, {
          position: "bottom-right",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(`Could not lower cart item quantity!`, {
          position: "bottom-right",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      // Call the function to update cart items after the DELETE request is done
      // Updatecartitems();
    } catch (error) {
      console.error("Error while deleting cart item:", error);
    }
  };


  async function fetchSearchResults(searchTerm) {
    setLoading(true);

    api.get(`/api/app/Products/SearchProducts/${searchTerm}`)
      .then(response => {
        const data = response.data;
        setSearchResults(data);
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        setLoading(false);
      });

  }






  const onChange = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setValue(searchTerm);
    if (searchTerm !== "") {
      fetchSearchResults(searchTerm);
    } else {
      setSearchResults([]);
    }
  };


  const logout = (e) => {
    localStorage.clear();
  };

  // useEffect(() => {

  //   console.log({ value });
  //   return () => {

  //   }
  // }, [value])


  function searchProductOnClick() {
    // var name = document.getElementById("searchName").value;
    const name = value;
    if (name == "") {
      return;
    } else {
      navigate({
        pathname: "/search",
        search: `?name=${name}`,
      });
      setValue("");
    }
  }

  function searchBrandOnClick(brandId) {
    const params = { type: "brand", id: brandId };
    navigate("/shop", { state: params });
    // navigate({
    //   pathname: '/shop',
    //   search: `?type=brand&id=${brandId}`,
    // });
  }

  function navigateToShopForAllCategories() {
    navigate("/shop", { state: { type: "hot" } });
  }

  const onSearch = (searchTerm) => {
    setValue(searchTerm);
  };
  function navigateToCategory(id) {
    const params = { type: "category", id: id };
    navigate("/shop", { state: params });
  }
  async function FetchMoreBrands() {


    setPageNo(c => (c + 1));
    if (hasMoreBrand) {
      fetchBrands(pageNo + 1)
    }

    return;

    // eslint-disable-next-line no-unreachable
    setslice(slice + 16);
    if (slice > TotalProducts) {
      toast.info("No More Brands to show!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  const drawerContainerRef = useRef();
  const toggleDrawer = () => {
    const element = window.document.getElementById("sideDrawerContainerId");
    const list = element.classList;
    list.toggle("sidebar-visible");
  }
  const closeDrawer = () => {
    const element = window.document.getElementById("sideDrawerContainerId");
    const list = element.classList;
    list.remove("sidebar-visible");
  }

  const LinkConnect = () => {
    console.log();
  }

  const handleGoBack = () => {
    navigate(-1);
  }

  return (
    <div>
      {/*Header starts Here*/}
      <div>
        {/* Quick view */}
        <header className="header-area header-style-1 header-height-2">
          <div className="mobile-promotion">
            {/* <span>
              <strong>5 % Discount</strong> on all Products
            </span> */}

            <FaArrowLeft
              style={{
                position: "absolute",
                left: "12px",
                top: "12px",
              }}
              role="button"
              onClick={handleGoBack}
            />
            <div className="header-info d-flex  justify-content-center  ">
              <ul>
                {/* <li>

                </li> */}
                <li>
                  <Link to="/about"> About Us </Link>
                </li>

                {token ? (
                  <>
                    <li>
                      <Link to="/MyAccount"> My Account </Link>
                    </li>
                    <li>
                      <Link to="/previous-order"> Order Tracking </Link>
                    </li>
                  </>
                ) : (
                  <></>
                )}
              </ul>
            </div>
          </div>
          <div className="header-top header-top-ptb-1 d-none d-lg-block">
            <div className="container">
              <div className="header-wrap">



                <div className="row align-items-center">
                  <div className="col-xl-12 col-lg-12">
                    <div className="header-info">
                      <ul>
                        <li>
                          <Link to="/about"> About Us </Link>
                        </li>

                        {token ? (
                          <>
                            <li>
                              <Link to="/myaccount"> My Account </Link>
                            </li>
                            <li>
                              <Link to="/previous-order"> Order Tracking </Link>
                            </li>
                          </>
                        ) : (
                          <></>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4">
                  <div className="text-center">
                    <div id="news-flash" className="d-inline-block">
                      <ul>
                        <li style={{ fontWeight: 400 }}>  <strong>5 % Discount</strong> on all Products</li>

                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4">
                  <div className="header-info header-info-right">
                    <ul>
                      <li>
                        Need help ? Call Us:{" "}
                        <strong style={{ color: "white" }}>
                          {" "}
                          + +91 7757947309{" "}
                        </strong>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="header-middle header-middle-ptb-1 d-none d-lg-block">
            <div className="container">
              <div className="header-wrap">
                <div className="logo logo-width-1">
                  <a href="/">
                    <img
                      src="assets/imgs/theme/grocer_cart_logo.jpg"
                      style={{ width: "130px", height: "auto" }}
                      alt="logo"
                    />
                  </a>
                </div>
                <div className="header-bottom header-right">
                  <div className="search-style-2" >


                    <form
                      ref={sourceDivRef}
                      style={{
                        // position: "relative",
                      }}
                      onSubmit={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <input
                        type="text"
                        id="searchName"
                        placeholder="Search for items..."
                        value={value}
                        onChange={onChange}
                        onFocus={open}
                        onBlur={close}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            searchProductOnClick();
                            setShowDropdown(false);
                          }
                        }}
                      />
                      <button
                        type="button"
                        onClick={searchProductOnClick}
                        className="btn btn-light"
                        style={{
                          position: "absolute",
                          right: "0%",
                          zIndex: "9999",
                        }}
                      >
                        Search
                      </button>
                    </form>
                    <div ref={targetDivRef} style={{
                      position: "relative"
                    }}>
                      {searchResults.length > 0 && isOptionVisible && <div className="dropdown shadow "
                        style={{
                          height: 200,
                          overflow: "auto",
                          borderLeft: "0.3px solid #ccc",
                          borderRight: "0.3px solid #ccc",
                          zIndex: 100
                        }}
                      >
                        {loading ? (
                          <div className="d- flex justify-content-end p-2 dropdown-row"  >
                            <Skeleton>
                              {/* <Spinner /> */}

                            </Skeleton>
                          </div>
                        ) : (
                          searchResults.map((item, i) => (
                            <div
                              className="dropdown-row"
                              onClick={() => {

                                // onSearch(item.name);
                                setShowDropdown(false);
                              }}
                              key={i}
                              style={{
                                borderBottom: "0.3px solid #ccc",

                                padding: "5px",
                                paddingLeft: "18px",
                                margin: 0
                              }}
                            >
                              {item.type === "products" ? (
                                <Link to={`/product-detail?id=${item.id}`}>
                                  {" "}
                                  {item.name}
                                </Link>
                              ) : (
                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                <a
                                  className="menu-title"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    switch (item.type) {
                                      case "Brand":
                                        searchBrandOnClick(item.id);
                                        break;
                                      case "Category":
                                        navigateToCategory(item.id)
                                        break;
                                      default:
                                        break;
                                    }
                                  }}
                                >
                                  {item.name}  {item.type != "products" ? " - " + item.type : ""}
                                </a>
                              )}
                            </div>
                          ))
                        )}
                      </div>}
                    </div>
                  </div>

                  <div className="header-action-right">
                    <div className="header-action-2">
                      {token ? (
                        <>
                          <div className="header-action-icon-2">
                            <Link className="mini-cart-icon" to="/cart">
                              <img
                                alt="Amruth E-Store desktop"
                                src="assets/imgs/theme/icons/icon-cart.svg"
                              />
                              <span className="pro-count white">
                                {" "}
                                {totalQuantity}{" "}
                              </span>
                            </Link>
                            <Link to="/cart">
                              {" "}
                              <span className="lable"> Cart </span>
                            </Link>
                          </div>
                          <div className="header-action-icon-2">
                            <Link to="/myaccount">
                              <img
                                className="svgInject"
                                alt="Amruth E-Store"
                                src="assets/imgs/theme/icons/icon-user.svg"
                              />
                            </Link>
                            <Link to="/myaccount">
                              {" "}
                              <span className="lable ml-0"> Account </span>
                            </Link>
                            <div className="cart-dropdown-wrap cart-dropdown-hm2 account-dropdown">
                              <ul>
                                <li>
                                  <Link to="/myaccount">
                                    <i className="fi fi-rs-user mr-10" /> My Account
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/previous-order">
                                    <i className="fi fi-rs-location-alt mr-10" />{" "}
                                    Order Tracking
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    onClick={(e) => {
                                      logout(e);
                                    }}
                                    to="/login"
                                  >
                                    <i className="fi fi-rs-sign-out mr-10" />{" "}
                                    Sign out
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>

                        </>
                      ) : (
                        <>
                          <div className="header-action-icon-2">
                            <Link to="/login">
                              <img
                                className="svgInject"
                                alt="Amruth E-Store"
                                src="assets/imgs/theme/icons/icon-user.svg"
                              />
                            </Link>
                            <Link to="/login">
                              {" "}
                              <span className="lable ml-0"> Sign in </span>
                            </Link>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={"header-bottom header-bottom-bg-color sticky-bar " + (isSticky ? " stick" : "")}


          >
            <div className="container">
              <div className="header-wrap header-space-between position-relative">
                <div className="header-action-icon-2 d-block d-lg-none">
                  <div className="burger-icon burger-icon-white" onClick={e => {
                    toggleDrawer();
                  }}>
                    <span className="burger-icon-top" />
                    <span className="burger-icon-mid" />
                    <span className="burger-icon-bottom" />
                  </div>
                </div>
                {/* <ArrowBackIcon id="arrow-back" onClick={() => navigate(-1)} /> */}
                <div className="logo logo-width-1 d-block d-lg-none">
                  <a href="/">
                    {" "}
                    <img src="assets/imgs/theme/logo.png" alt="logo t" />{" "}
                  </a>
                </div>
                <div className="header-nav d-none d-lg-flex">
                  <div className="main-categori-wrap d-none d-lg-block">
                    <>
                      <a
                        className="categories-button-active"
                        onClick={() => navigateToShopForAllCategories()}
                      >
                        <span className="fi-rs-apps" />{" "}
                        <span className="et"> Browse </span> All Categories
                      </a>
                    </>

                    <div className="categories-dropdown-wrap categories-dropdown-active-large font-heading">
                      <div className="d-flex categori-dropdown-inner">
                        <ul>
                          <li>
                            <Link to="/shop">
                              {" "}
                              <img
                                src="assets/imgs/theme/icons/category-1.svg"
                                alt=""
                              />{" "}
                              Milks and Dairies{" "}
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop">
                              {" "}
                              <img
                                src="assets/imgs/theme/icons/category-2.svg"
                                alt=""
                              />{" "}
                              Clothing & amp; beauty{" "}
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop">
                              {" "}
                              <img
                                src="assets/imgs/theme/icons/category-3.svg"
                                alt=""
                              />{" "}
                              Pet Foods & amp; Toy{" "}
                            </Link>
                          </li>
                          <li>
                            <a href="shop">
                              {" "}
                              <img
                                src="assets/imgs/theme/icons/category-4.svg"
                                alt=""
                              />{" "}
                              Baking material{" "}
                            </a>
                          </li>
                          <li>
                            <a href="shop">
                              {" "}
                              <img
                                src="assets/imgs/theme/icons/category-5.svg"
                                alt=""
                              />{" "}
                              Fresh Fruit{" "}
                            </a>
                          </li>
                        </ul>
                        <ul className="end">
                          <li>
                            <a href="shop">
                              {" "}
                              <img
                                src="assets/imgs/theme/icons/category-7.svg"
                                alt=""
                              />{" "}
                              Fresh Seafood{" "}
                            </a>
                          </li>
                          <li>
                            <a href="shop">
                              {" "}
                              <img
                                src="assets/imgs/theme/icons/category-8.svg"
                                alt=""
                              />{" "}
                              Fast food{" "}
                            </a>
                          </li>
                          <li>
                            <a href="shop">
                              {" "}
                              <img
                                src="assets/imgs/theme/icons/category-9.svg"
                                alt=""
                              />{" "}
                              Vegetables{" "}
                            </a>
                          </li>
                          <li>
                            <a href="shop">
                              {" "}
                              <img
                                src="assets/imgs/theme/icons/category-10.svg"
                                alt=""
                              />{" "}
                              Bread and Juice{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div
                        className="more_slide_open"
                        style={{ display: "none" }}
                      >
                        <div className="d-flex categori-dropdown-inner">
                          <ul>
                            <li>
                              <a href="shop">
                                {" "}
                                <img
                                  src="assets/imgs/theme/icons/icon-1.svg"
                                  alt=""
                                />{" "}
                                Milks and Dairies{" "}
                              </a>
                            </li>
                            <li>
                              <a href="shop">
                                {" "}
                                <img
                                  src="assets/imgs/theme/icons/icon-2.svg"
                                  alt=""
                                />{" "}
                                Clothing & amp; beauty{" "}
                              </a>
                            </li>
                          </ul>
                          <ul className="end">
                            <li>
                              <a href="shop">
                                {" "}
                                <img
                                  src="assets/imgs/theme/icons/icon-3.svg"
                                  alt=""
                                />{" "}
                                Wines & amp; Drinks{" "}
                              </a>
                            </li>
                            <li>
                              <a href="shop">
                                {" "}
                                <img
                                  src="assets/imgs/theme/icons/icon-4.svg"
                                  alt=""
                                />{" "}
                                Fresh Seafood{" "}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="more_categories">
                        {" "}
                        <span className="icon" />{" "}
                        <span className="heading-sm-1"> Show more...</span>
                      </div>
                    </div>
                  </div>
                  <div className="main-menu main-menu-padding-1 main-menu-lh-2 d-none d-lg-block font-heading ">
                    <nav>
                      <ul>
                        <li>
                          <Link className="position-static" to="/home">
                            Home
                          </Link>
                        </li>

                        <li className="position-static">
                          <Link to="shop">
                            {" "}
                            Brands <i className="fi-rs-angle-down" />{" "}
                          </Link>
                          <ul className="mega-menu" style={{ overflow: "auto", height: 250 }}>
                            {brandList
                              // .slice(0, slice)
                              .map((item) => (
                                <li
                                  key={item.id}
                                  className="sub-mega-menu sub-mega-menu-width-22"
                                >
                                  <Link
                                    className="menu-title"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      searchBrandOnClick(item.id)
                                    }}
                                  >
                                    {item.name}
                                  </Link>
                                </li>
                              ))}
                            <li>
                              <div
                                className="pt-5"
                                style={{ textAlign: "center", marginBottom: 10 }}
                              >
                                <Link
                                  onClick={FetchMoreBrands}
                                  style={{ display: "flex" }}
                                >
                                  Load More Brands
                                </Link>

                              </div>
                            </li>

                          </ul>
                        </li>

                        <li>
                          <Link to="/about"> About </Link>
                        </li>
                        <li>
                          <Link to="/contact"> Contact Us </Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <div className="hotline d-none d-lg-flex">
                  <img
                    src="assets/imgs/theme/icons/icon-headphone.svg"
                    alt="hotline"
                  />
                  <p>
                    +91 7757947309 <span> 24 / 7 Support Center </span>
                  </p>
                </div>
                <div className="header-action-icon-2 d-block d-lg-none">
                  {/* <SearchIcon/> */}
                  {/* <img src="assets/imgs/theme/search.png" alt="search" class="custom-image search-icon" onclick={toggleSearchInput()}/> */}
                  {/* <input type="text" class="search-input" id="searchInput" placeholder="Search..." onblur={hideSearchInput()}/> */}
                </div>

                {/* mobile view  */}
                <div className="header-action-right d-block d-lg-none">
                  <div className="header-action-2">

                    {/* <div className="header-action-icon-2">
                      <Link onClick={e => {
                        setShowMobile(!showMobile);
                      }} >
                        <>
                          <i className="fi-rs-search text-black-50 " id="searchOpenId" />


                        </>
                      </Link>
                    </div> */}

                    {/* Mobile Showing Part */}
                    {token ? (
                      <>
                        <div className="header-action-icon-2 ml-2 mr-1">
                          <Link
                            // className="mini-cart-icon"
                            to="cart">
                            <img
                              alt="Amruth E-Store"
                              src="assets/imgs/theme/icons/icon-cart.svg" />
                            {totalQuantity && <span className="pro-count white">
                              {totalQuantity}
                            </span>}
                          </Link>

                        </div>
                        {/* <div className="header-action-icon-2">
                          <Link to="/myaccount">
                            <img
                              className="svgInject"
                              alt="Amruth E-Store"
                              src="assets/imgs/theme/icons/icon-user.svg" />
                          </Link>
                          <Link to="/myaccount">
                            <span className="lable ml-0"> Sign in </span>
                          </Link>
                        </div> */}

                      </>
                    ) : (
                      <div className="header-action-icon-2">
                        <Link to="/login">
                          <img
                            className="svgInject"
                            alt="Amruth E-Store"
                            src="assets/imgs/theme/icons/icon-user.svg" />
                        </Link>
                        <Link to="/login">
                          {" "}
                          <span className="lable ml-0"> Sign in </span>
                        </Link>
                      </div>
                    )}




                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        <OutsideClickedComponent onOutsideClick={e => {
          if (Capacitor.getPlatform() !== "web") {
            console.log("Outside ", e);
            if (drawerContainerRef.current?.classList.contains('sidebar-visible')) {
              toggleDrawer();
            }
          }
        }}>
          <div id="sideDrawerContainerId" ref={drawerContainerRef} className="mobile-header-active mobile-header-wrapper-style  ">
            <div className="mobile-header-wrapper-inner">
              <div className="mobile-header-top">
                <div className="mobile-header-logo">
                  <Link to="/">

                    <img src="assets/imgs/theme/logo.png" alt="logo" id="top_mobile_logo" />{" "}
                  </Link>
                </div>
                <div className="mobile-menu-close close-style-wrap close-style-position-inherit">
                  <button className="close-style search-close" onClick={closeDrawer}>
                    <i className="icon-top" />
                    <i className="icon-bottom" />
                  </button>
                </div>
              </div>
              <div className="mobile-header-content-area">
                {/* <DrawerSearch closeDrawer={closeDrawer} /> */}

                <div className="mobile-menu-wrap mobile-header-border">
                  {/*Mobile Menu Start */}

                  <nav>
                    <ul className="mobile-menu font-heading">


                      {/* {token && <li className=" menu-item d-flex  justify-content-between " to="/shop-product-right#">
                        Cart
                        <span style={{ position: "relative" }}>
                          <img
                            alt="Amruth E-Store desktop"
                            src="assets/imgs/theme/icons/icon-cart.svg"
                          />
                          <span className="count-show-custom white">
                            {" "}
                            {totalQuantity}{" "}
                          </span>
                        </span>
                      </li>} */}
                      <Link to="/" onClick={closeDrawer}>
                        <li className="menu-item">
                          Home
                        </li>
                      </Link>

                      {token && <>      <li className="menu-item d-flex  justify-content-between">
                        <Link to="/myaccount" onClick={closeDrawer}>
                          My Account
                        </Link>
                      </li>
                        <li className="menu-item d-flex  justify-content-between">
                          <Link to="/previous-order" onClick={closeDrawer}>
                            Order Tracking
                          </Link>
                        </li></>}

                      <li className="menu-item-has-children">
                        <Link to="/shop" onClick={closeDrawer}>
                          Categories
                        </Link>
                      </li>

                      <li className="menu-item-has-children">
                        <Link to="/about" onClick={closeDrawer}>
                          About Us
                        </Link>
                      </li>
                      <li className="menu-item">
                        <Link to="/contact" onClick={closeDrawer}>
                          Contact Us
                        </Link>
                      </li>

                    </ul>
                  </nav>
                </div>
                <div className="mobile-header-info-wrap">
                  {/* <div className="single-mobile-header-info">
                    <a href="shop">
                      {" "}
                      <i className="fi-rs-marker" /> Our location{" "}
                    </a>
                  </div> */}
                  {token ?
                    <>

                    </>
                    : <div className="single-mobile-header-info">
                      <a href="login">
                        <i className="fi-rs-user" /> Log In / Sign Up{" "}
                      </a>
                    </div>}
                  <div className="single-mobile-header-info">
                    <a href="tel:7757947309">
                      <i className="fi-rs-headphones" /> +91 7757947309{" "}
                    </a>
                  </div>
                </div>
                <div className="mobile-social-icon mb-50">
                  <h6 className="mb-15"> Follow Us </h6>
                  <a href="shop">
                    <img
                      src="assets/imgs/theme/icons/icon-facebook-white.svg"
                      alt=""
                    />
                  </a>
                  <a href="shop">
                    <img
                      src="assets/imgs/theme/icons/icon-twitter-white.svg"
                      alt=""
                    />
                  </a>
                  <a href="shop">
                    <img
                      src="assets/imgs/theme/icons/icon-instagram-white.svg"
                      alt=""
                    />
                  </a>
                  <a href="shop">
                    <img
                      src="assets/imgs/theme/icons/icon-pinterest-white.svg"
                      alt=""
                    />
                  </a>
                  <a href="shop">
                    <img
                      src="assets/imgs/theme/icons/icon-youtube-white.svg"
                      alt=""
                    />
                  </a>
                </div>
                <div className="site-copyright">
                  Copyright 202 © Grocer Cart.All rights reserved.
                </div>
              </div>

            </div>
          </div>
        </OutsideClickedComponent>

      </div >
      {
        <Card className="show-mobile-only" >
          <Card.Body className="p-1 w-100 ">
            <div className="search-style-1" >
              <form
                ref={sourceDivRef}
                style={{
                  // position: "relative",
                  width: "100%"
                }}
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <input
                  type="text"
                  id="searchName2"
                  placeholder="Search for items...."
                  value={value}
                  onChange={onChange}
                  onFocus={open}
                  onBlur={close}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      searchProductOnClick();
                      setShowDropdown(false);
                      close()
                    } else {
                      open();
                    }
                  }}
                />
                <button
                  type="button"
                  onClick={e => {
                    searchProductOnClick()
                  }}
                  className="btn btn-light"
                  style={{
                    position: "absolute",
                    right: "0%",
                    zIndex: "9999",
                    borderRadius: "40px",
                  }}
                >
                  Search
                </button>
              </form>
              <div ref={targetDivRef} style={{
                position: "relative"
              }}>
                {searchResults.length > 0 && isOptionVisible && <div className="dropdown shadow "
                  style={{
                    height: 400,
                    overflow: "auto",
                    borderLeft: "0.1px solid #ccc",
                    borderRight: "0.1px solid #ccc",
                    borderRadius: 15
                  }}
                >
                  {loading ? (
                    <div className="d- flex justify-content-end p-2 dropdown-row"  >
                      <Skeleton /></div>
                  ) : (
                    searchResults.map((item, i) => (
                      <div
                        className="dropdown-row"
                        onClick={() => {

                          // onSearch(item.name);
                          setShowDropdown(false);
                        }}
                        key={i}
                        style={{
                          borderBottom: "0.3px solid #ccc",

                          padding: "5px",
                          paddingLeft: "18px",
                          margin: 0
                        }}
                      >
                        {item.type === "products" ? (
                          <Link to={`/product-detail?id=${item.id}`} style={{
                            fontSize: 20,
                          }}>
                            {" "}
                            {item.name}
                          </Link>
                        ) : (
                          <a
                            className="menu-title"
                            style={{
                              fontSize: 20,

                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              switch (item.type) {
                                case "Brand":
                                  searchBrandOnClick(item.id);
                                  break;
                                case "Category":
                                  navigateToCategory(item.id)
                                  break;
                                default:
                                  break;
                              }
                            }}
                          >
                            {item.name}  {item.type != "products" ? " - " + item.type : ""}
                          </a>
                        )}
                      </div>
                    ))
                  )}
                </div>}
              </div>
            </div>
          </Card.Body>
        </Card >
      }



    </div >
  );
};

export default Header;
